export const environment = {
    production: false,
    urlredirectweinvoice: 'https://console-merchant.wepay4u.com/login', // invoice
    urlredirectwepay: 'https://console-merchant.wepay4u.com/login', // console merchant
    urlredirectwecourier: 'https://console-merchant.wepay4u.com/login', // wecourier
    api_url_invoice: 'https://api-console-weinvoice.wepay4u.com/',
    api_url_cachin: 'https://api-cms-merchant.wepay4u.com/api/v1/'
};

